/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssessmentManagementControllerUpdateCompleteAssessmentRequestQuestionsInnerOptionsInner } from './assessmentManagementControllerUpdateCompleteAssessmentRequestQuestionsInnerOptionsInner';


export interface AssessmentManagementControllerUpdateCompleteAssessmentRequestQuestionsInner { 
    id?: string;
    questionText?: string;
    questionType?: string;
    sectionId?: string;
    sectionIndex?: number;
    orderIndex?: number;
    isRequired?: boolean;
    settings?: object;
    options?: Array<AssessmentManagementControllerUpdateCompleteAssessmentRequestQuestionsInnerOptionsInner>;
}

